//lib
import classNames from "classnames";
import React, { useState } from "react";

//src
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { IconButton } from "@mui/material";
import { TableActionMenuStyled } from "./table-action-menu.style";
import NestedMenu from "./menu/menu";
import { isSomething } from "../../utils/utils";

const TableActionMenu = ({
  options,
  disabled,
  customIcon,
  variant = "light",
  width = 180,
  paperSx,
  position = "right",
  noBorder = false,
  bgVariant,
  anchorOrigin,
  transformOrigin,
}) => {
  const [actionMenuEl, setActionMenuEl] = useState(null);

  return (
    <>
      <TableActionMenuStyled>
        <span className="action-menu">
          <IconButton
            disableRipple
            onClick={(event) => setActionMenuEl(event.currentTarget)}
            className={classNames({
              "menu-icon": true,
              // "menu-opened": !!actionMenuEl && !customIcon,
              "def-background": bgVariant === "outlined",
              disabled: disabled,
            })}
            id={`list-btn`}
            disabled={disabled}
          >
            {isSomething(customIcon) ? customIcon : <MoreVertIcon />}
          </IconButton>

          {actionMenuEl ? (
            <NestedMenu
              noBorder={noBorder}
              options={options}
              parentClose={() => setActionMenuEl(null)}
              parentElement={actionMenuEl}
              variant={variant}
              width={width}
              paperSx={paperSx}
              position={position}
              anchorOrigin={anchorOrigin}
              transformOrigin={transformOrigin}
            />
          ) : null}
        </span>
      </TableActionMenuStyled>
    </>
  );
};

export default TableActionMenu;
